/*
 * The pace of a sentence typing itself out, and the arithmetic on it. Kept
 * apart from `Typewriter`, which only draws a given number of characters, so a
 * caller can size its own timer to the sentence before anything is drawn.
 */

/** The pause after a sentence is shown before its first character appears. */
export const TYPING_LEAD = 250;

/** The time between one character and the next. Fast enough to read as typing, not dictation. */
export const TYPING_STEP = 22;

/** How long `text` takes to type out in full, lead included. */
export function typingTime(text: string) {
  return TYPING_LEAD + text.length * TYPING_STEP;
}

/** How many characters of `text` are showing `elapsed` milliseconds in. */
export function typedLength(text: string, elapsed: number) {
  const typed = Math.floor((elapsed - TYPING_LEAD) / TYPING_STEP);
  return Math.min(Math.max(typed, 0), text.length);
}
